import React from 'react';

const SecondaryNav: React.FC = () => null;

export default SecondaryNav;
